import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {HashRouter} from 'react-router-dom'
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";


i18next.init({
    interpolation: { escapeValue: false },

});

ReactDOM.render(
    <HashRouter>
        <I18nextProvider i18n={i18next}>
        <App/>
        </I18nextProvider>
    </HashRouter>,
    document.getElementById('root')
);


